import type {
  EventMarketPeriodTypes,
  EventMarketType,
  EventRunnerType,
  EventType,
} from "app/types/eventType";
import { RunnerTypes } from "app/utils/const";
import { kebabCase } from "lodash";
import { HomeAwaySidesHelper } from "../../helpers/HomeAwaySidesHelper";
import "../../HomeAwaySides.scss";
import EmptyRunner from "../EmptyRunner/EmptyRunner";
import HomeAwaySidesRunner from "../HomeAwaySidesRunner/HomeAwaySidesRunner";

export default function Home(props: {
  home?: EventRunnerType[];
  event: EventType;
  market: EventMarketType;
  marketType: EventMarketPeriodTypes;
  addBetSlip: Function;
}) {
  const { event, home, marketType, addBetSlip } = props;

  return (
    <div className={`${RunnerTypes.HOME} ${kebabCase(marketType.marketType)}`}>
      {home &&
        home.map(runner => {
          // check if market has runners
          // or if Ui needs to display empty Runner when no prices availbale
          const displayEmptyRunner =
            HomeAwaySidesHelper.checkDisplayEmptyRunner(runner, marketType);

          return (
            <div key={runner.id}>
              {displayEmptyRunner && (
                <>
                  <EmptyRunner runner={runner} />
                </>
              )}
              {!displayEmptyRunner && (
                <HomeAwaySidesRunner
                  event={event}
                  runner={runner}
                  side={RunnerTypes.HOME}
                  addBetSlip={addBetSlip}
                />
              )}
            </div>
          );
        })}
    </div>
  );
}
